import {
  notification,
} from 'antd';
import { useEffect } from 'react';
import { withSSRContext } from 'aws-amplify';
import { useRouter } from 'next/router';
import SC from '../Signup/style';
import hnaRequest from '../../utils/hnaRequest';
import useAuth from 'hooks/useAuth';
import { SvgLogoSmallLoader } from 'components/Svgs';

const SigninWithToken = () => {
  const { query } = useRouter();
  let { confirmToken } = query;
  const { token } = query;
  const { login } = useAuth();
  const { Auth } = withSSRContext();

  if (confirmToken) {
    confirmToken = decodeURIComponent(confirmToken as string);
  }

  const finish = async () => {
    try {
      // logout any exsiting prior users
      await Auth.signOut();
      localStorage.clear();

      const response = await hnaRequest('post', 'connect/signin-user', { confirmToken, token });
      const { token: challengeToken, email } = response.data;
      const user: any = await Auth.signIn(email);
      const signedUser = await Auth.sendCustomChallengeAnswer(user, challengeToken);
      console.log('signedUser ::', signedUser);
      login(signedUser);

      notification.success({
        message: 'Inscription réussie, bienvenue !',
      });
    } catch (error) {
      console.log('error confirming user:', error);
    }
  };

  useEffect(() => {
    if (confirmToken || token) {
      finish();
    }
  }, []);

  return (
    <SC.DivSignup>
      <div css={SC.autoLoginMessage}>
        <p>Votre profil a bien été créé.</p>
        <p>Plus que quelques secondes, l'Academy ouvre ses portes...</p>
        <div css={SC.loaderAutoSignin}>
          <SvgLogoSmallLoader />
        </div>
        <p>Vous allez être redirigé vers la page d'accueil.</p>
      </div>
    </SC.DivSignup>
  );
};

export default SigninWithToken;
